import { ref, computed } from 'vue';
import { getApi } from '../../init';
import to from 'await-to-js';
import { GetSkusRes } from '../../apis/entities';
import { ORG_TYPE } from '../../constants';

interface IOptions {
  getOrgInfo: Function;
  getUserInfo: Function;
  getLingdouInfo: Function;
  activityCode?: string;
}

export function usePayment(options: IOptions) {
  const { getOrgInfo, getLingdouInfo, getUserInfo, activityCode } = options;
  const skus = ref<GetSkusRes[]>([]);
  const skuLoading = ref(true);
  const skuError = ref(false);
  const orgInfo = ref();
  const userInfo = ref();
  const lingdouInfo = ref();
  const activeSkuId = ref();
  const activityDetail = ref();
  const refreshPayComponentKey = ref(0);
  const activeSku = computed(() => skus.value.find((s) => s.skuId === activeSkuId.value));
  const isPersonal = computed(() =>
    orgInfo.value ? orgInfo.value.type === ORG_TYPE.PERSONAL : true,
  );

  const isAdmin = computed(
    () => !!userInfo.value?.roles?.find((r) => ['admin', 'superAdmin'].includes(r)),
  );

  const isVip = computed(() => lingdouInfo?.value?.memberShip?.member);

  async function getSkus() {
    skuError.value = false;
    // const [err, res] = await to(getApi().aiadTransactionsApi.getSkus());
    const { aiadTransactionsApi } = getApi();
    const [err, res] = await to(
      Promise.all([
        aiadTransactionsApi.getSkus(),
        activityCode && aiadTransactionsApi.getActivitySkus(activityCode),
      ]),
    );
    if (!err) {
      if (activityCode) {
        skus.value = (res[1] as any)?.concat(res[0]);
        console.log(skus.value);
      } else {
        skus.value = res[0];
      }
    } else {
      // @ts-ignore
      err?.preventDefault?.();
      skuError.value = true;
    }
  }

  async function getActivity() {
    if (!activityCode) return;
    const { aiadTransactionsApi } = getApi();
    activityDetail.value = await aiadTransactionsApi.getActivity(activityCode);
  }

  async function init() {
    skuLoading.value = true;
    await Promise.all([
      getSkus(),
      getUserInfo?.().then((v) => {
        userInfo.value = v;
      }),

      getOrgInfo?.().then((v) => {
        orgInfo.value = v;
      }),
      getLingdouInfo?.().then((v) => {
        lingdouInfo.value = v;
      }),
      getActivity(),
    ]);
    skuLoading.value = false;
  }

  function handleActiveSku(skuId) {
    if (activeSkuId.value === skuId) {
      return;
    }
    activeSkuId.value = skuId;

    // 重新渲染pay组件
    refreshPayComponentKey.value++;
  }

  return {
    skus,
    skuLoading,
    skuError,
    orgInfo,
    userInfo,
    lingdouInfo,
    activeSkuId,
    activeSku,
    init,
    handleActiveSku,
    isPersonal,
    isAdmin,
    isVip,
    refreshPayComponentKey,
    activityDetail,
  };
}
